import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { slideBanners } from '@/mocks/comics';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 600);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % slideBanners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const banner = slideBanners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div
        className="absolute inset-0 transition-opacity duration-500"
        style={{ opacity: isTransitioning ? 0.8 : 1 }}
      >
        <img
          src={banner.image}
          alt={banner.title}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className={`absolute inset-0 bg-gradient-to-b ${banner.color}`}></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <div className="max-w-3xl w-full">
          <h2 className="text-2xl md:text-5xl font-bold text-white mb-3 md:mb-4 drop-shadow-lg" style={{ fontFamily: "var(--font-heading)" }}>
            {banner.title}
          </h2>
          <p className="text-sm md:text-lg text-white/90 mb-6 md:mb-8 drop-shadow">
            {banner.subtitle}
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to={`/comic/${banner.comicId}`}
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-900 rounded-full font-semibold text-sm hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line w-5 h-5 flex items-center justify-center"></i>
              立即阅读
            </Link>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/20 text-white rounded-full font-semibold text-sm backdrop-blur-sm hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer border border-white/30"
            >
              浏览全部
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {slideBanners.map((_, idx) => (
          <button
            key={idx}
            onClick={() => goTo(idx)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              idx === current ? 'bg-white w-6' : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`切换到第${idx + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}